import generalSection from "../_section/section.class";
import {adminProofOfPPSNUpload, userProofOfPPSNUpload} from "./upload";
import ApplicationForm from "./ApplicationForm";
import DataForm from "./DataForm";

export class userProofOfPPSNSection extends generalSection {
    // errors on section, upload-steps on uploads
    constructor(request, mortgage, props, statementUploadFactory = null) {
        super(request, mortgage, props, statementUploadFactory ?? userProofOfPPSNUpload);
        // Add missing date error

    }
}

export class adminProofOfPPSNSection extends userProofOfPPSNSection {
    constructor(request, mortgage, props) {
        super(request, mortgage, props, adminProofOfPPSNUpload);
        this.ApplicationForm = ApplicationForm
        this.DataForm = DataForm
        this.sortByDateProp('documentDate');
        this.activeUpload = this.uploads.find(u=> u.allValuesAnswered && u.isVerifiable)
        this.setProblems(this.problemsList.singleUploadUserProblems())
    }
    get documentDate() {
        return this.activeUpload?.values?.documentDate || null;
    }
    get ppsn() {
        return this.activeUpload?.values?.ppsn || null;
    }

    getSectionSummary = () => {
        return [
            {
                name: this.personalTitle,
                tags: [
                    {
                        name: 'PPSN',
                        value: this.ppsn || 'N/A'
                    },
                    {
                        name: 'Document Date',
                        value: this.documentDate ? this.documentDate.format('D MMM YYYY') : 'N/A'
                    }
                ]
            }
        ]
    }
}